import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useStateContext } from '../../context/ContextProvider';
import { DLabel, Select, DSpinButton, TextArea } from '../utils/Form';
import { getAllCategorys } from '../../redux/actions/category';
import { toast } from 'react-toastify';
import { Loader } from '../utils';
import { BaseUrl } from '../../server';
import ImageUploadWithResize from '../../utils/ImageUploadWithResize';

function CreateMeal() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();
  const { isLoading, AllCategorys } = useSelector((state) => state.Categorys);
  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
  const [titleAr, setTitleAr] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [textEn, setTextEn] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [textAr, setTextAr] = useState("");
  const [date, setDate] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState(null);
  const [imageShow, setImageShow] = useState(null);
  
  // ✅ إضافة مفتاح لإعادة تحميل المكون
  const [uploadKey, setUploadKey] = useState(0);

  useEffect(() => {
    dispatch(getAllCategorys());
  }, [dispatch]);

  const CreateBlog = async (newForm) => {
    try {
      const config = { 
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true 
      };
      const { data } = await axios.post(`${BaseUrl}/blogs/create`, newForm, config);
      
      if (data.success) {
        toast.success(
          <span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">
            {t("Meal created successfully!")}
          </span>
        );

        // إعادة تعيين جميع الحالات
        setIsSpinner(false);
        setTitleAr("");
        setTitleEn("");
        setTextAr("");
        setTextEn("");
        setCategoryId("");
        setDate("");
        setImage(null);
        setPrice("");
        setImageShow(null);
        
        // ✅ إعادة تحميل مكون رفع الصور بالكامل
        setUploadKey(prev => prev + 1);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      toast.error(
        <span className="font-kufi text-sm">
          {typeof errorMessage === 'string' ? errorMessage : t("An error occurred")}
        </span>
      );
      setIsSpinner(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!image) {
      toast.error(t("Please select an image"));
      return;
    }
    if (!categoryId) {
      toast.error(t("Please select a category"));
      return;
    }
    
    setIsSpinner(true);
    const newForm = new FormData();
    newForm.append("file", image);
    newForm.append("categoryId", categoryId);
    if (date) newForm.append("date", date);
    newForm.append("titleAr", titleAr);
    newForm.append("titleEn", titleEn);
    newForm.append("textAr", textAr);
    newForm.append("textEn", textEn);
    if (price) newForm.append("price", price);

    CreateBlog(newForm);
  };

  // ✅ دالة لإعادة التعيين اليدوي
  const resetForm = () => {
    setTitleAr("");
    setTitleEn("");
    setTextAr("");
    setTextEn("");
    setCategoryId("");
    setDate("");
    setImage(null);
    setPrice("");
    setImageShow(null);
    setUploadKey(prev => prev + 1); // إعادة تحميل مكون الصور
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10 rounded-3xl">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-color-1 font-kufi color">
              {t("Create Meal")}
            </h3>
            {/* ✅ زر إعادة تعيين النموذج بالكامل */}
            <button
              type="button"
              onClick={resetForm}
              className="px-4 py-2 text-sm bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors font-kufi"
              style={{ color: currentColor }}
            >
              {t("Reset Form")}
            </button>
          </div>
          
          <form onSubmit={handleSubmit}>
            <br />
            <div>
              <DLabel
                labelText="Title (Ar)"
                value={titleAr}
                onChange={(e) => setTitleAr(e.target.value)}
                required={true}
                type="text"
                name="titleAr"
              />
              <DLabel
                labelText="Title (En)"
                value={titleEn}
                onChange={(e) => setTitleEn(e.target.value)}
                required={true}
                type="text"
                name="titleEn"
              />
              <DLabel
                labelText="Price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required={false}
                type="number"
                name="price"
              />
              <Select 
                Data={AllCategorys} 
                labelText={t("Select Category")} 
                value={categoryId} 
                setValue={setCategoryId} 
                required={true} 
              />
              <TextArea 
                labelText={t("Description (Ar)")} 
                value={textAr} 
                onChange={(e) => setTextAr(e.target.value)} 
                required={true} 
              />
              <TextArea 
                labelText={t("Description (En)")} 
                value={textEn} 
                onChange={(e) => setTextEn(e.target.value)} 
                required={true} 
              />

              {/* ✅ إضافة key لإعادة تحميل المكون عند الحاجة */}
              <ImageUploadWithResize
                key={uploadKey}
                imageShow={imageShow}
                setImageShow={setImageShow}
                setImage={setImage}
                currentColor={currentColor}
                label="Upload Image"
                required={true}
                maxWidth={1024}
                maxHeight={1024}
                quality={80}
              />
              
              <br />
            </div>
            <DSpinButton isLoading={isSpinner}>
              {isSpinner ? t("Creating...") : t("Create")}
            </DSpinButton>
          </form>
        </div>
      )}
    </>
  );
}

export default CreateMeal;